import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { useDispatch } from "react-redux";
import CustomIconSelect from "../expenseModule/defaultSelectIcon";
import { validetPrifix } from "jsFunctions/generatePoNumber";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { useToasts } from "react-toast-notifications";
import orgJson from "components/jsonData/orgnization.json";
import { formatInvoicePrifix } from "jsFunctions/generatePoNumber";
import { fetchAsyncCreateSalesInvoiceModule } from "redux/salesInvoiceModuleSlice";
import { fetchAsyncUpdateSalesInvoieModule } from "redux/salesInvoiceModuleSlice";
import { saleModuleIcon } from "../expenseModule/moduleIcon";
import { defaultPayTerms } from "./paymentTerms";
import { FaCheck } from "react-icons/fa";

const InvoiceModuleForm = ({ isOpen, onClose, isEdit,editData }) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [activeTab,setActiveTab] = useState('invoice')
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    moduleName: "",
    prifix: "",
    pfPrifix: "",
    color: "",
    icnImg: "",
    invStart:0,
    pfStart:0
  });

  useEffect(() => {
    if (editData && isEdit) {
      setFormData({
        moduleName: editData?.name,
        prifix: editData?.prfx,
        pfPrifix: editData?.pfPrfx,
        color: editData?.clr || "",
        icnImg: editData?.icnImg,
        invStart: editData?.sInv,
        pfStart:editData?.sPf
      });
    }
  }, [editData, isEdit]);

  const validate = () => {
    const newErrors = {};

    if (!formData.moduleName) newErrors.moduleName = "Module name is required!";
    if (!formData.prifix) newErrors.prifix = "prifix is required!";
    if (!formData.pfPrifix) newErrors.pfPrifix = "Proforma prifix is required!";

    if (formData.prifix && !validetPrifix(formData.prifix)) {
      newErrors.prifix =
        "Prifix is invalid. It must be between 5 and 9 characters long.";
    }
    if (formData.pfPrifix && !validetPrifix(formData.pfPrifix)) {
      newErrors.pfPrifix =
        "Prifix is invalid. It must be between 5 and 9 characters long.";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const toCamelCase = (value) => {
    return value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    let defaultPrfx = formData.prifix || "";
    let defaultPfPrfx = formData.pfPrifix || "";

    if (name === "moduleName") {
      formattedValue = toCamelCase(value);
    }
    if (name === "moduleName" && !defaultPrfx) {
      defaultPrfx = "INVOICE-";
    }
    if (name === "moduleName" && !defaultPfPrfx) {
      defaultPfPrfx = "PROFORMA-"
    }

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
      prifix: defaultPrfx,
      pfPrifix:defaultPfPrfx
    }));
  };

  const handleCreateSalesInvoiceModule = (data) => {
        
    const formDataToSend = new FormData();
    formDataToSend.append("formdata", JSON.stringify(formData));
    formDataToSend.append("paymentTerms", JSON.stringify(defaultPayTerms));

    dispatch(fetchAsyncCreateSalesInvoiceModule(formDataToSend))
      .then((res) => {
        if (res?.payload) {
          addToast(orgJson.success.createSalesModule, { appearance: "success" });
          onClose()
        } else {
          addToast(res?.error?.message, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(orgJson.error.generic, { appearance: "error" });
      });
  };

  const handleAddModule = (e) => {
    e.preventDefault();
    if (validate()) {
      ConfirmationDialog({
        title: "Are you sure? You want to create module",
        text: `Module Name : ${formData?.moduleName}`,
        icon: "warning",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          handleCreateSalesInvoiceModule(formData);
        },
      });
    }
  };

  const handleEditModule = (e) => {
    e.preventDefault();
    if (validate()) {
      const formDataToSend = new FormData();
      formDataToSend.append("formdata", JSON.stringify(formData));
      dispatch(fetchAsyncUpdateSalesInvoieModule({id:editData?._id,data:formDataToSend}))
      .then((res) => {
        if (res?.payload) {
          addToast(orgJson.success.updateSalesModule, { appearance: "success" });
          onClose()

        } else {
          addToast(res?.error?.message, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(orgJson.error.generic, { appearance: "error" });
      });
    } 
  };

  const handleChangePrifix = (e) => {
    const { value } = e.target;
    const formattedValue = value.toUpperCase();

    if (/^[A-Z]/.test(formattedValue)) {
      const formVal = formatInvoicePrifix(formattedValue);
      setFormData((prev) => ({
        ...prev,
        prifix: formVal,
      }));
      setErrors({prifix:""});
    } else {
      setErrors({prifix:"Prefix must start with a letter."});
      setFormData((prev) => ({
        ...prev,
        prifix: "",
      }));
    }
  };
  const handleChangePfPrifix = (e) => {
    const { value } = e.target;
    const formattedValue = value.toUpperCase();

    if (/^[A-Z]/.test(formattedValue)) {
      const formVal = formatInvoicePrifix(formattedValue);
      setFormData((prev) => ({
        ...prev,
        pfPrifix: formVal,
      }));
      setErrors({pfPrifix:""});
    } else {
      setErrors({pfPrifix:"Prefix must start with a letter."});
      setFormData((prev) => ({
        ...prev,
        pfPrifix: "",
      }));
    }
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered className="">
        <ModalOverlay />
        <ModalContent
          maxH="fit-content"
          className="add-account-user-modal sales-invoice-module-modal"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              {isEdit ? "Edit" : "Add"} Invoice Module
            </ModalHeader>
            <ModalCloseButton />
          </div>
          <ModalBody className="mt-5 px-2 py-1 form-card">
          <h5 className="mt-0">Module Details</h5>

            <Row>
              <Col>
                <Form.Label>
                  <span className="required">Module Name*</span>
                </Form.Label>
                <Form.Control
                  className={`form-control ${isEdit ? "disabled-field" : ""}`}
                  type="text"
                  name="moduleName"
                  value={formData?.moduleName}
                  onChange={handleChange}
                  disabled={isEdit}
                />
                {errors?.moduleName && (
                  <p className="form_error">{errors?.moduleName}</p>
                )}
              </Col>
            </Row>
            <Row className="icon-color-row">
              <Col>
                <Form.Label>
                  <span>Module Icon</span>
                </Form.Label>
                <CustomIconSelect
                  icnId={formData?.icnImg}
                  onChange={(e) => handleChange(e)}
                  moduleOption={saleModuleIcon}
                />
              </Col>
              <Col>
                <Form.Label>
                  <span>Module Color</span>
                </Form.Label>
                <Form.Control
                  className="form-control color-input-field"
                  type="color"
                  name="color"
                  value={formData?.color}
                  onChange={handleChange}
                />
              </Col>
            </Row>
            <Tabs
              defaultActiveKey={activeTab}
              transition={false}
              id="noanim-tab-example"
              className="add-form-tabs m-0"
              onSelect={(K) => setActiveTab(K)}
              
            >
              <Tab
                eventKey="invoice"
                title={
                  <div className="d-flex ">
                    Invoices
                    {formData?.prifix && <FaCheck size={12} className="tab-icon" />}
                  </div>
                }
                className="add-form-tab" 
              >
            <Row className="mt-2">
              <Col>
                <Form.Label>
                  <span className="required">Prifix*</span>
                </Form.Label>
                <Form.Control
                  className={`form-control ${isEdit ? "disabled-field" : ""}`}
                  type="text"
                  name="prifix"
                  disabled={isEdit}
                  value={formData?.prifix}
                  onChange={handleChangePrifix}
                />
                {errors?.prifix && (
                  <p className="form_error">{errors?.prifix}</p>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>
                  <span>Start From</span>
                </Form.Label>
                <Form.Control
                  className={`form-control ${isEdit ? "disabled-field" : ""}`}
                  type="Number"
                  name="invStart"
                  value={formData?.invStart}
                  onChange={handleChange}
                  disabled={isEdit}
                />
              </Col>
            </Row>
              </Tab>
              <Tab
                eventKey="proforma"
                title={
                  <div className="d-flex ">
                    Proforma
                    {formData?.pfPrifix && <FaCheck size={12} className="tab-icon" />}
                  </div>
                }
                className="add-form-tab mx-0"
              >

            <Row className="mt-2">
              <Col>
                <Form.Label>
                  <span className="required">Prifix*</span>
                </Form.Label>
                <Form.Control
                  className={`form-control ${isEdit ? "disabled-field" : ""}`}
                  type="text"
                  name="pfPrifix"
                  disabled={isEdit}
                  value={formData?.pfPrifix}
                  onChange={handleChangePfPrifix}
                />
                {errors?.pfPrifix && (
                  <p className="form_error">{errors?.pfPrifix}</p>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>
                  <span>Start From</span>
                </Form.Label>
                <Form.Control
                  className={`form-control ${isEdit ? "disabled-field" : ""}`}
                  type="Number"
                  name="pfStart"
                  value={formData?.pfStart}
                  onChange={handleChange}
                  disabled={isEdit}
                />
              </Col>
            </Row>
              </Tab>
            </Tabs>

           
          </ModalBody>

          <ModalFooter className="fixed-module-footer">
            <Button
              onClick={isEdit ? handleEditModule : handleAddModule}
              className="btn save-btn"
              mr={3}
            >
              {isEdit ? "Edit" : "Add"}
            </Button>
            <Button onClick={onClose} className="btn">
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default InvoiceModuleForm;
